<template>
  <h3>VIZBI Collective</h3>

  <p>
    The VIZBI Collective is an international network of scientists, animators, and visual artists
    from the VIZBI community, who come together for projects at the
    intersection of the life sciences, data visualisation, and public outreach. We produce
    animations, projection mappings, and live events that combine scientific accuracy with
    compelling visuals. The Collective grew out of
    <router-link to="/Plus">VizbiPlus</router-link>.
  </p>

  <PortfolioHeading subtitle="Outcomes from the VIZBI Collective" />
  <VideoGallery collection="Collective" is-sorted-by-year is-looping />
</template>

<script setup>
import VideoGallery from "@/components/VideoGallery.vue";
import PortfolioHeading from "@/components/PortfolioHeading.vue";
</script>
